import { IPageComponent } from '@maxpreps/shared/models/pageTypes';
import React from 'react';
import {
  IScheduleContextProviderProps,
  ScheduleContextProvider
} from '../../components/schedule/ScheduleContext';
import SchedulePage from '../../components/schedule/SchedulePage';
import gssp, { pageConfig } from '../../data/schedule/index.gssp';
import { ITeamMetaPageProps } from '../../utils/ITeamPageConfig';

export interface IScheduleIndexProps
  extends IScheduleContextProviderProps,
    ITeamMetaPageProps {
  feedbackLink: string;
}

const ScheduleIndex: IPageComponent<IScheduleIndexProps> = ({
  contests,
  standings,
  leagueStandings,
  ...rest
}) => (
  <ScheduleContextProvider
    contests={contests}
    leagueStandings={leagueStandings}
    standings={standings}
  >
    <SchedulePage {...rest} />
  </ScheduleContextProvider>
);

ScheduleIndex.pageConfig = pageConfig;

export default ScheduleIndex;

export const getServerSideProps = gssp;
